import React, { useEffect, useRef } from "react";
import CloseIcon from "@/assets/icon/close.svg";

const Modal = ({ isOpen, onClose, children, className="", customClose =null}) => {
  const dialogRef = useRef(null);

  const handleOutsideClick = (e) => {
    if (e.target === dialogRef.current) {
      onClose();
    }
  };

  useEffect(() => {
    const dialog = dialogRef.current;
    if (isOpen && dialog) {
      dialog.showModal();
    } else if (dialog) {
      dialog.close();
    }
  }, [isOpen]);

  return (
    <dialog
      ref={dialogRef}
      className={`tw-w-[calc(100%-40px)] tw-max-w-[600px] tw-box-border tw-max-h[calc(100%-40px)] md:tw-max-h-full tw-rounded-[10px] tw-shadow-lg ${className}`}
      onClose={onClose}
      onClick={handleOutsideClick}
    >
      <div className="tw-flex tw-justify-end">
        {
          customClose ??
          <button className="tw-mt-3 tw-mr-3.5 tw-mb-0" onClick={onClose}>
            <img src={CloseIcon} alt="" className="" />
          </button>
        }
      </div>
      <div className="tw-p-6 tw-pt-2">{children}</div>
    </dialog>
  );
};

export default Modal;
